"use client";

import React from "react";

import { SectionTitle } from "../section-title";
import { SkeletonBox } from "../skeleton-box";

interface ClusterSelectionListSkeletonProps {
  sectionTitle: string;
  rowCount?: number;
  showTrailingSkeleton?: boolean;
}

export const ClusterSelectionListSkeleton: React.FC<ClusterSelectionListSkeletonProps> = ({
  sectionTitle,
  rowCount = 3,
  showTrailingSkeleton = false,
}) => {
  return (
    <div>
      <SectionTitle title={sectionTitle} />
      <div className="mt-2 space-y-3">
        {Array.from({ length: rowCount }, (_, index) => (
          <div
            key={index}
            className="flex gap-2 border-b border-gray-200 py-2.5"
          >
            <SkeletonBox className="h-5 flex-1" />
            {showTrailingSkeleton ? <SkeletonBox className="h-4 w-16 shrink-0" /> : null}
            <SkeletonBox className="h-5 w-5 shrink-0 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
};
